import React, { type FC } from "react";

import { EmptyState, Fonts } from "@snapchat/snap-design-system";

import noResults from "../../assets/dashboard/no-results.png";

import { Flexbox } from "../../core/components";

import { emptyResultsContainer, emptyResultsImage, emptyResultsImageContainer } from "./NoResults.style";

interface NoResultsProps {
    description: string;
    addItem?: React.ReactElement;
}

export const NoResults: FC<NoResultsProps> = ({ description, addItem }) => (
    <Flexbox className={emptyResultsContainer} flexDirection="column" justifyContent="center" alignItems="center">
        <EmptyState
            className={emptyResultsImageContainer}
            imageClassName={emptyResultsImage}
            imageUrl={noResults}
            title={<span style={Fonts.Heading.H400}>{description}</span>}
        />
        {addItem}
    </Flexbox>
);
